/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../app/nls/StringResources'
], function(
	StringResources
) {
	const getTabIcons = function(icons) {
		return [
			{
				name: 'transparent',
				label: StringResources.get('no_icon'),
				type: 'ColorCode',
				value: 'transparent'
			},
			{
				name: 'bullhorn',
				label: StringResources.get('announcement'),
				type: 'svg',
				value: icons.getIcon('bullhorn').id
			},
			{
				name: 'api',
				label: StringResources.get('api'),
				type: 'svg',
				value: icons.getIcon('api').id
			},
			{
				name: 'archive',
				label: StringResources.get('archive'),
				type: 'svg',
				value: icons.getIcon('archive').id
			},
			{
				name: 'microphone',
				label: StringResources.get('asset'),
				type: 'svg',
				value: icons.getIcon('microphone').id
			},
			{
				name: 'attachment',
				label: StringResources.get('attachment'),
				type: 'svg',
				value: icons.getIcon('attachment').id
			},
			{
				name: 'audio',
				label: StringResources.get('audio'),
				type: 'svg',
				value: icons.getIcon('audio').id
			},
			{
				name: 'bee',
				label: StringResources.get('bee'),
				type: 'svg',
				value: icons.getIcon('bee').id
			},
			{
				name: 'blog',
				label: StringResources.get('blog'),
				type: 'svg',
				value: icons.getIcon('blog').id
			},
			{
				name: 'bookmark',
				label: StringResources.get('bookmark'),
				type: 'svg',
				value: icons.getIcon('bookmark').id
			},
			{
				name: 'calendar',
				label: StringResources.get('calendar'),
				type: 'svg',
				value: icons.getIcon('calendar').id
			},
			{
				name: 'camera',
				label: StringResources.get('camera'),
				type: 'svg',
				value: icons.getIcon('camera').id
			},
			{
				name: 'capability',
				label: StringResources.get('capability'),
				type: 'svg',
				value: icons.getIcon('capability').id
			},
			{
				name: 'catalog',
				label: StringResources.get('catalog'),
				type: 'svg',
				value: icons.getIcon('catalog').id
			},
			{
				name: 'message',
				label: StringResources.get('chat_message'),
				type: 'svg',
				value: icons.getIcon('message').id
			},
			{
				name: 'checkout',
				label: StringResources.get('checkout_cart'),
				type: 'svg',
				value: icons.getIcon('checkout').id
			},
			{
				name: 'client',
				label: StringResources.get('client'),
				type: 'svg',
				value: icons.getIcon('client').id
			},
			{
				name: 'clock',
				label: StringResources.get('clock'),
				type: 'svg',
				value: icons.getIcon('clock').id
			},
			{
				name: 'cloud',
				label: StringResources.get('cloud'),
				type: 'svg',
				value: icons.getIcon('cloud').id
			},
			{
				name: 'code',
				label: StringResources.get('code'),
				type: 'svg',
				value: icons.getIcon('code').id
			},
			{
				name: 'data-quality',
				label: StringResources.get('data_quality'),
				type: 'svg',
				value: icons.getIcon('data-quality').id
			},
			{
				name: 'folder',
				label: StringResources.get('folder'),
				type: 'svg',
				value: icons.getIcon('folder').id
			},
			{
				name: 'forum',
				label: StringResources.get('forum'),
				type: 'svg',
				value: icons.getIcon('forum').id
			},
			{
				name: 'glasses',
				label: StringResources.get('glasses'),
				type: 'svg',
				value: icons.getIcon('glasses').id
			},
			{
				name: 'group',
				label: StringResources.get('group'),
				type: 'svg',
				value: icons.getIcon('group').id
			},
			{
				name: 'hat',
				label: StringResources.get('hat'),
				type: 'svg',
				value: icons.getIcon('hat').id
			},
			{
				name: 'headphones',
				label: StringResources.get('headphone'),
				type: 'svg',
				value: icons.getIcon('headphones').id
			},
			{
				name: 'hills',
				label: StringResources.get('hills'),
				type: 'svg',
				value: icons.getIcon('hills').id
			},
			{
				name: 'home',
				label: StringResources.get('home'),
				type: 'svg',
				value: icons.getIcon('home').id
			},
			{
				name: 'idea',
				label: StringResources.get('idea'),
				type: 'svg',
				value: icons.getIcon('idea').id
			},
			{
				name: 'image',
				label: StringResources.get('image'),
				type: 'svg',
				value: icons.getIcon('image').id
			},
			{
				name: 'inventory',
				label: StringResources.get('inventory'),
				type: 'svg',
				value: icons.getIcon('inventory').id
			},
			{
				name: 'like',
				label: StringResources.get('like'),
				type: 'svg',
				value: icons.getIcon('like').id
			},
			{
				name: 'link',
				label: StringResources.get('link'),
				type: 'svg',
				value: icons.getIcon('link').id
			},
			{
				name: 'location',
				label: StringResources.get('location'),
				type: 'svg',
				value: icons.getIcon('location').id
			},
			{
				name: 'pen',
				label: StringResources.get('pen'),
				type: 'svg',
				value: icons.getIcon('pen').id
			},
			{
				name: 'mobile',
				label: StringResources.get('mobile_phone'),
				type: 'svg',
				value: icons.getIcon('mobile').id
			},
			{
				name: 'music',
				label: StringResources.get('music'),
				type: 'svg',
				value: icons.getIcon('music').id
			},
			{
				name: 'notifications',
				label: StringResources.get('notifications'),
				type: 'svg',
				value: icons.getIcon('notifications').id
			},
			{
				name: 'paint',
				label: StringResources.get('paint'),
				type: 'svg',
				value: icons.getIcon('paint').id
			},
			{
				name: 'payment',
				label: StringResources.get('payment'),
				type: 'svg',
				value: icons.getIcon('payment').id
			},
			{
				name: 'password-key',
				label: StringResources.get('password_key'),
				type: 'svg',
				value: icons.getIcon('password-key').id
			},
			{
				name: 'people',
				label: StringResources.get('people'),
				type: 'svg',
				value: icons.getIcon('people').id
			},
			{
				name: 'person',
				label: StringResources.get('person'),
				type: 'svg',
				value: icons.getIcon('person').id
			},
			{
				name: 'phone',
				label: StringResources.get('phone'),
				type: 'svg',
				value: icons.getIcon('phone').id
			},
			{
				name: 'pin',
				label: StringResources.get('pin'),
				type: 'svg',
				value: icons.getIcon('pin').id
			},
			{
				name: 'print',
				label: StringResources.get('print'),
				type: 'svg',
				value: icons.getIcon('print').id
			},
			{
				name: 'recording',
				label: StringResources.get('recording'),
				type: 'svg',
				value: icons.getIcon('recording').id
			},
			{
				name: 'repository',
				label: StringResources.get('repository'),
				type: 'svg',
				value: icons.getIcon('repository').id
			},
			{
				name: 'role',
				label: StringResources.get('role'),
				type: 'svg',
				value: icons.getIcon('role').id
			},
			{
				name: 'search',
				label: StringResources.get('search'),
				type: 'svg',
				value: icons.getIcon('search').id
			},
			{
				name: 'settings',
				label: StringResources.get('settings'),
				type: 'svg',
				value: icons.getIcon('settings').id
			},
			{
				name: 'speaker',
				label: StringResources.get('speaker'),
				type: 'svg',
				value: icons.getIcon('speaker').id
			},
			{
				name: 'star',
				label: StringResources.get('star'),
				type: 'svg',
				value: icons.getIcon('star').id
			},
			{
				name: 'tag',
				label: StringResources.get('tag'),
				type: 'svg',
				value: icons.getIcon('tag').id
			},
			{
				name: 'thumbs-up',
				label: StringResources.get('thumbs_up'),
				type: 'svg',
				value: icons.getIcon('thumbs-up').id
			},
			{
				name: 'thumbs-down',
				label: StringResources.get('thumbs_down'),
				type: 'svg',
				value: icons.getIcon('thumbs-down').id
			},
			{
				name: 'tools',
				label: StringResources.get('tools'),
				type: 'svg',
				value: icons.getIcon('tools').id
			},
			{
				name: 'traffic',
				label: StringResources.get('traffic'),
				type: 'svg',
				value: icons.getIcon('traffic').id
			},
			{
				name: 'trash',
				label: StringResources.get('trash'),
				type: 'svg',
				value: icons.getIcon('trash').id
			},
			{
				name: 'twitter',
				label: StringResources.get('twitter'),
				type: 'svg',
				value: icons.getIcon('twitter').id
			},
			{
				name: 'unknown',
				label: StringResources.get('unknown'),
				type: 'svg',
				value: icons.getIcon('unknown').id
			},
			{
				name: 'user',
				label: StringResources.get('user'),
				type: 'svg',
				value: icons.getIcon('user').id
			},
			{
				name: 'venn-diagram',
				label: StringResources.get('venn_diagram'),
				type: 'svg',
				value: icons.getIcon('venn-diagram').id
			},
			{
				name: 'video',
				label: StringResources.get('video'),
				type: 'svg',
				value: icons.getIcon('video').id
			},
			{
				name: 'view',
				label: StringResources.get('view'),
				type: 'svg',
				value: icons.getIcon('view').id
			},
			{
				name: 'warning',
				label: StringResources.get('warning'),
				type: 'svg',
				value: icons.getIcon('warning').id
			},
			{
				name: 'watch',
				label: StringResources.get('watch'),
				type: 'svg',
				value: icons.getIcon('watch').id
			},
			{
				name: 'watson',
				label: StringResources.get('watson'),
				type: 'svg',
				value: icons.getIcon('watson').id
			},
			{
				name: 'wikis',
				label: StringResources.get('wikis'),
				type: 'svg',
				value: icons.getIcon('wikis').id
			},
			{
				name: 'workspace',
				label: StringResources.get('workspace'),
				type: 'svg',
				value: icons.getIcon('workspace').id
			},
			{
				name: 'world',
				label: StringResources.get('world'),
				type: 'svg',
				value: icons.getIcon('world').id
			}
		];
	};

	return {
		getTabIcons
	};
});